var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.597,
    height: 124.636,
    viewBox: "0 0 33.495 32.976",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    strokeWidth: 0.065,
    d: "M29.939 32.874a3.923 3.923 0 01-.59-.271c-.142-.085-2.025-1.914-4.186-4.064l-3.928-3.909-.49.321c-1.58 1.033-3.7 1.767-5.852 2.025-.802.096-2.644.043-3.51-.102a13.692 13.692 0 01-6.055-2.61c-.734-.553-2.087-1.923-2.63-2.662C1.174 19.526.296 17.247.06 14.752-.481 9.047 2.685 3.602 7.943 1.194 9.808.34 11.422-.002 13.574 0c1.642.002 2.895.209 4.398.726 5.717 1.966 9.495 7.661 9.06 13.657-.148 2.038-.61 3.652-1.571 5.49l-.448.859 3.989 3.986c4.34 4.338 4.286 4.275 4.455 5.18.208 1.121-.446 2.355-1.515 2.857-.37.173-.514.203-1.05.218-.465.013-.706-.012-.953-.099zm-15.02-10.326c2.732-.443 5.083-2.03 6.495-4.383 1.598-2.665 1.678-6.154.206-8.933a9.246 9.246 0 00-4.635-4.194c-1.166-.476-2.154-.661-3.507-.658-2.255.006-4.23.748-5.946 2.233a9.14 9.14 0 00-2.956 8.71c.178.873.33 1.317.75 2.187 1.293 2.674 3.854 4.57 6.81 5.041.74.118 2.046.116 2.782-.003z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ed17f8ca0c4d98a720b1a82ceafe1a47.svg";
export { ForwardRef as ReactComponent };